// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"9ce95d37","120":"eca84409","237":"78651c3e","397":"1f994b46","405":"b8f24038","472":"c95d42a3","532":"2a03f0d1","633":"d1834955","647":"35c5d3c1"}[chunkId] + ".chunk.js";
};